import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { ReviewSet } from '../models/review/review-set.model';
import { PagingResponse } from '@models/paging-response.model';
import { BulkDocAddPayload } from '../models/review/bulk-doc-add-payload.model';
import { Guid } from "@models/guid";

@Injectable({
  providedIn: 'root'
})
export class ReviewSetService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  getReviewSets(): Observable<ReviewSet[]> {
    return this.http.get<ReviewSet[]>(`${this.appConfigService.getConfig().webApi}/api2/reviewSets`)
      .pipe(catchError(this.errorHandler.handleError<ReviewSet[]>(`get review sets`)));
  }

  getReviewSetsStatusPreReview(): Observable<ReviewSet[]> {
    return this.http.get<ReviewSet[]>(`${this.appConfigService.getConfig().webApi}/api2/reviewSets?$filter=Status eq 0`)
      .pipe(catchError(this.errorHandler.handleError<ReviewSet[]>(`get review sets`)));
  }

  addDocsToReviewSet(reviewSetId: string, payload: BulkDocAddPayload): Observable<any> {
    return this.http.put(`${this.appConfigService.getConfig().webApi}/api2/reviewSets/${reviewSetId}/bulk`, payload)
      .pipe(catchError(this.errorHandler.handleError<PagingResponse<any>>(`patch review set`)));
  }

  getNextReviewDoc(reviewSetId: string, curDocId: string): Observable<string> {
    return this.http.get<string>(`${this.appConfigService.getConfig().webApi}/api2/reviewSets/${ reviewSetId }/docs/${ curDocId || Guid.Empty }/next`)
      .pipe(catchError(this.errorHandler.handleError<string>(`get next review doc`)));
  }

  getRemainingReviewDocCount(reviewSetId: string): Observable<number> {
    return this.http.get<number>(`${this.appConfigService.getConfig().webApi}/api2/reviewSets/${ reviewSetId }/remainingCount`)
      .pipe(catchError(this.errorHandler.handleError<number>(`get remaining review doc count`)));
  }
}
